import { Component, OnInit } from '@angular/core';
import { ApiService } from '../../core/http/api.service';
import { UtilsService } from '../../core/services/utils/utils.service';

@Component({
  selector: 'app-twitter-webhook-requests',
  templateUrl: './twitter-webhook-requests.component.html',
  styleUrls: ['./twitter-webhook-requests.component.css'],
  standalone: false,
})
export class TwitterWebhookRequestsComponent implements OnInit {
  loading = true;
  requests: any[] = [];
  page = 1;
  perPage = 20;
  total = 0;
  selectedRequest: any = null;
  selectedGoldenHandle: any = null;
  payloadTab: 'posts' | 'raw' = 'posts';

  constructor(private api: ApiService, private utils: UtilsService) {}

  ngOnInit(): void {
    this.loadRequests();
  }

  loadRequests(): void {
    this.loading = true;
    this.api.getTwitterWebhookRequests({ page: this.page, limit: this.perPage }).subscribe(
      (res) => {
        this.requests = Array.isArray(res?.data) ? res.data : [];
        this.total = Number(res?.meta?.total || 0);
        this.loading = false;
      },
      (err) => {
        this.loading = false;
        this.utils.resErr(err);
      },
    );
  }

  pageChange(page: number): void {
    this.page = page;
    this.selectedRequest = null;
    this.loadRequests();
  }

  openPayload(request: any): void {
    this.selectedRequest = request;
    this.payloadTab = 'posts';
  }

  closePayload(): void {
    this.selectedRequest = null;
  }

  openGoldenHandle(goldenHandle: any): void {
    this.selectedGoldenHandle = goldenHandle;
  }

  closeGoldenHandle(): void {
    this.selectedGoldenHandle = null;
  }

  deleteRequest(request: any): void {
    if (!confirm('Permanently delete this webhook request?')) return;

    this.api.deleteTwitterWebhookRequest(request._id).subscribe(
      () => {
        this.utils.toastSuccess('Webhook request deleted successfully');
        if (this.requests.length === 1 && this.page > 1) this.page -= 1;
        this.loadRequests();
      },
      (err) => this.utils.resErr(err),
    );
  }

  get selectedTweets(): any[] {
    return Array.isArray(this.selectedRequest?.payload?.tweets)
      ? this.selectedRequest.payload.tweets
      : [];
  }

  get selectedDuplicateCount(): number {
    const received = Number(this.selectedRequest?.receivedCount || 0);
    const added = Number(this.selectedRequest?.savedCount || 0);
    return Math.max(received - added, 0);
  }

  tweetImage(tweet: any): string {
    const media = tweet?.extendedEntities?.media || tweet?.entities?.media || [];
    const mediaUrl = media[0]?.media_url_https || media[0]?.media_url;
    if (mediaUrl) return mediaUrl;

    const imageBinding = tweet?.card?.binding_values?.find(
      (binding: any) => binding?.key === 'photo_image_full_size_large',
    );
    return imageBinding?.value?.image_value?.url || '';
  }

  compactCount(value: unknown): string {
    return Intl.NumberFormat('en', { notation: 'compact' }).format(Number(value || 0));
  }
}
